import { render, staticRenderFns } from "./GridSix.vue?vue&type=template&id=0e4fbfe4&scoped=true&"
import script from "./GridSix.vue?vue&type=script&lang=js&"
export * from "./GridSix.vue?vue&type=script&lang=js&"
import style0 from "./GridSix.vue?vue&type=style&index=0&id=0e4fbfe4&scoped=true&lang=stylus&"


/* normalize component */
import normalizer from "!../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  "0e4fbfe4",
  null
  
)

export default component.exports